import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: spacing(75),
    width: '100%',
    padding: spacing(0, 71),
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
  },
  title: {
    fontFamily: Theme.Typography.FontFamily.DMSans,
    fontWeight: Theme.Typography.FontWeight.Medium,
    fontSize: Theme.Typography.FontSize.Large,
    lineHeight: '112.5%',
    color: Theme.Colors.Grayscale.OneThousand,
  },
  tableContainer: {
    flex: 1,
    margin: spacing(20, 71),
  },
  mainTable: {
    width: 'auto',
    height: 630,
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cellText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  root: {
    padding: 0,

    '& .MuiPaper-root': {
      width: '100%',
    },
  },
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: spacing(14),
    marginRight: spacing(14),
    marginBottom: spacing(14),
  },
  attachment: {
    '& .MuiCardMedia-root': {
      minWidth: '160px !important',
      minHeight: '160px !important',
    },
  },
}))

export const dataGridStyle = {
  fontSize: '1.4rem',

  '& .MuiDataGrid-cell:hover': {
    cursor: 'pointer',
  },
}
